<headerCustom></headerCustom>
<!--Add User Modal Box-->
<div *ngIf="showHideModel" class="modal fade" id="managementUserDailogContainer" tabindex="-1" role="dialog"
    aria-labelledby="managementUserDailogContainer" aria-hidden="true">
    <div class="modal-dialog  modal-dialog-centered" role="document">
        <form [formGroup]="managementUserForm">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Management Users Detail Form</h5>
                    <button type="button" class="close" #closeModel data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <input *ngIf="managementUserForm.value.userId" type="hidden" formControlName="userId">
                <div class="modal-body">
                    <div class="form-group row">
                        <label for="userFullName" class="col-sm-5 col-form-label control-label">Full Name</label>
                        <div class="col-sm-7">
                            <input type="text" [ngClass]="{ 'is-invalid': submitted && f.userFullName.errors }"
                                onfocus="this.placeholder = ''" onblur="this.placeholder = 'User Full Name'"
                                placeholder="User Full Name" class="form-control" formControlName="userFullName">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="userName" class="col-sm-5 col-form-label control-label">User Name</label>
                        <div class="col-sm-7">
                            <input type="text" [ngClass]="{ 'is-invalid': submitted && f.userName.errors }"
                                onfocus="this.placeholder = ''" onblur="this.placeholder = 'User Name'"
                                placeholder="User Name" class="form-control" formControlName="userName">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="userEmail" class="col-sm-5 col-form-label control-label">Email</label>
                        <div class="col-sm-7">
                            <input type="text" [ngClass]="{ 'is-invalid': submitted && f.userEmail.errors }"
                                onfocus="this.placeholder = ''" onblur="this.placeholder = 'User Email'"
                                placeholder="User Email" class="form-control" formControlName="userEmail" email>
                        </div>
                    </div>
                    
                    <div class="form-group row">
                        <label for="userRoll" class="col-sm-5 col-form-label control-label">User Role</label>
                        <div class="col-sm-7">
                            <select class="form-control form-control-lg" (change)="changeRole($event)"
                                [ngClass]="{ 'is-invalid': submitted && f.userRoll.errors }" placeholder="User Type"
                                formControlName="userRoll">
                                <option>Select Role</option>
                                <option *ngFor="let userRole of userRoles" value="{{userRole.roleId}}">
                                    {{userRole.roleName}}
                                </option>
                            </select>
                        </div>
                    </div>

                 
                    <!-- [checked]="selectedUserIbu.includes(item.ibuId)" -->
                    <div class="form-group row" *ngIf="isHrUser">
                    <label for="towerId" class="col-sm-5 col-form-label control-label">Select IBU</label>
                        <div class="col-sm-7">
                            <ng-container *ngFor="let item of this.updatedIbuList let i = index;">
                                <label class="row">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <input type="checkbox" id="{{i}}" [checked]="item.isChecked" [value]="item.ibuId" (change)="onCheckboxChange($event)" />
                                    &nbsp;&nbsp; {{item.ibuName}} 
                                </label>
                            </ng-container>
                        </div>
                    </div>
                   
                    <div class="form-group row">
                        <label for="userStatus" class="col-sm-5 col-form-label control-label">User Status</label>
                        <div class="col-sm-7">
                            <select class="form-control form-control-lg"
                                [ngClass]="{ 'is-invalid': submitted && f.userStatus.errors }" placeholder="User Status"
                                formControlName="userStatus">
                                <option>User Status</option>
                                <option>Active</option>
                                <option>Inactive</option>
                            </select>
                        </div>
                    </div>
                    
                </div>
                <div class="modal-footer">
                    <button *ngIf="!managementUserForm.value.userId" class="btn hvr-bounce-to-top"
                        (click)="onSubmit(managementUserForm.value)" [disabled]="managementUserForm.invalid">Add
                        Management User
                    </button>
                    <button *ngIf="managementUserForm.value.userId" type="button" class="btn hvr-bounce-to-top"
                        (click)="updateManagementUserInfo(managementUserForm.value)">Update Management User</button>
                    <button type="button" class="btn hvr-bounce-to-top" data-dismiss="modal"
                        aria-label="Close">Cancel</button>
                </div>
            </div>
        </form>
    </div>
</div>

<app-admin-sidebar *ngIf="isSuperAdmin"></app-admin-sidebar>
<sidebarWrapper *ngIf="!isSuperAdmin"></sidebarWrapper>

<div class="main-content">
    <div class="adduserContainer">
        <div class="pageContentWrapper">
            <div class="pageHeading">
                <div class="row">
                    <div class="col-8">
                        <div class="headerName">
                            <div class="labelLinks">
                                <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb">
                                        <!-- <li class="breadcrumb-item">
                                            <a [routerLink]="['/adminDashboard']">View Admin Dashboard</a>
                                        </li> -->
                                        <li class="breadcrumb-item active" aria-current="page">Management Users
                                            Information</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 addUserButton">
                        <button type="button" data-toggle="modal" data-backdrop="static" data-keyboard="false"
                            data-target="#managementUserDailogContainer" (click)="initUserInfo()">Add User</button>
                    </div>
                </div>
            </div>
            <div class="addUserButtonTableData" *ngIf="managementUserInfoList.length >0">
                <div class="addUserFormContainer addUserFormLayout customizeRtsScrollBar">
                    <table datatable="ng"
                        class="table table-striped lh-23 rsTable userRcCustomTable customizeRtsScrollBar">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Full Name</th>
                                <th>User Name</th>
                                <th>Email</th>
                                <th>User Role</th>
                                <th data-orderable="false">Action</th>
                            </tr>
                        </thead>
                        <tbody class="text-center">
                            <tr *ngFor="let managementUser of managementUserInfoList; let i = index;">
                                <td>
                                    <div>{{managementUserInfoList.indexOf(managementUser) + 1}}</div>
                                </td>
                                <td>
                                    <div>{{managementUser.userFullName}}</div>
                                </td>
                                <td>
                                    <div>{{managementUser.userName}}</div>
                                </td>
                                <td>
                                    <div>{{managementUser.userEmail}}</div>
                                </td>
                                <td>
                                    <div>{{managementUser.roleName}}</div>
                                </td>
                                <td class="addUserButtons">
                                    <button class="btn form-group hvr-bounce-to-top" data-backdrop="static"
                                        data-keyboard="false" title="Edit" type="button" data-toggle="modal"
                                        data-target="#managementUserDailogContainer"
                                        (click)="setUpdateUserInfo(managementUser)">
                                        <img src="assets/edit.svg" />
                                    </button>
                                    <!-- <button class="btn form-group hvr-bounce-to-top" title="Delete" type="button"
                        (click)="onDeleteSubmit(managementUser)">
                        <img src="assets/delete.svg" />
                      </button> -->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="loader" *ngIf="loading">
    <div class="lds-roller">
        <!-- <img src="assets/preloader.gif" />
        <span>Wait...</span> -->
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>